import { Stack, Text } from '@chakra-ui/react'

import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import type { UserDetails } from '@/components/Worlds/types'
import Avatar from '@/components/Worlds/UI/Avatar/Avatar'

export default function LiveHelpSessionLabel({
  user,
}: {
  user: Pick<UserDetails, 'id' | 'username' | 'displayName' | 'avatarUrl'>
}): JSX.Element {
  const { id, username, displayName } = user

  return (
    <Stack direction="row" alignItems="center" spacing="16px" minW="216px">
      <Avatar user={user} size="md" />
      <Text fontWeight="bold">
        Zoom Session with{' '}
        <ShwLink
          href={getUserUrl({ userId: id, username })}
          variant="unstyled"
          textDecoration="underline"
          _hover={{ textDecoration: 'underline' }}
          fontSize="16px"
        >
          {displayName}
        </ShwLink>
      </Text>
    </Stack>
  )
}
